import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { PAGE_TOOLBAR } from './pageToolbarStyles'

interface PageToolbarProps {
  /** Linha 1: abas + controles à direita */
  navigation: ReactNode
  /** Controles opcionais (ícones, toggle de visão) — alinhados à direita */
  controls?: ReactNode
  /** Linha 2: busca, selects, botão Filtros */
  filters?: ReactNode
  className?: string
}

/** Container padrão — 2 linhas (nav + filtros), igual Deals */
export function PageToolbar({ navigation, controls, filters, className }: PageToolbarProps) {
  return (
    <div className={cn(PAGE_TOOLBAR.shell, className)}>
      <div className={cn(PAGE_TOOLBAR.row, 'w-full justify-between gap-2')}>
        <div className='min-w-0 flex-1'>{navigation}</div>
        {controls ? <div className='ml-auto flex shrink-0 items-center gap-2'>{controls}</div> : null}
      </div>
      {filters ? <div className='min-w-0'>{filters}</div> : null}
    </div>
  )
}
